import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Pencil, Trash2 } from "lucide-react";
import { Header, EditModal, Grid2, Input } from "./AdminSimulators";

const empty = { name: "", logo_url: "", website: "", order: 0, active: true };

export default function AdminClients() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = async () => setItems((await api.get("/admin/clients")).data);
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editing.id) await api.put(`/admin/clients/${editing.id}`, editing);
      else await api.post("/admin/clients", editing);
      toast.success("Salvo");
      setEditing(null);
      load();
    } catch (e) { toast.error("Erro"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Excluir?")) return;
    await api.delete(`/admin/clients/${id}`);
    load();
  };

  return (
    <div data-testid="admin-clients">
      <Header title="Clientes" onCreate={() => setEditing({ ...empty })} />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.map((c) => (
          <div key={c.id} className="rounded-xl border border-white/5 bg-[#0a0a0a] p-6 flex flex-col items-center justify-center aspect-video">
            {c.logo_url ? <img src={c.logo_url} alt={c.name} className="max-h-16 object-contain" /> : <div className="font-display font-black text-lg text-neutral-400">{c.name}</div>}
            <div className="mt-4 flex gap-2">
              <button onClick={() => setEditing(c)} className="p-2 rounded-lg border border-white/10"><Pencil className="w-3 h-3" /></button>
              <button onClick={() => remove(c.id)} className="p-2 rounded-lg border border-white/10 hover:border-[#E31B23]"><Trash2 className="w-3 h-3" /></button>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <EditModal onClose={() => setEditing(null)} onSave={save} title={editing.id ? "Editar cliente" : "Novo cliente"}>
          <Input label="Nome*" v={editing.name} on={(v) => setEditing({ ...editing, name: v })} />
          <Input label="URL do logo" v={editing.logo_url} on={(v) => setEditing({ ...editing, logo_url: v })} />
          <Input label="Website" v={editing.website} on={(v) => setEditing({ ...editing, website: v })} />
          <Grid2>
            <Input label="Ordem" type="number" v={editing.order} on={(v) => setEditing({ ...editing, order: Number(v) })} />
            <label className="flex items-center gap-2 mt-8"><input type="checkbox" checked={editing.active} onChange={(e) => setEditing({ ...editing, active: e.target.checked })} /> Ativo</label>
          </Grid2>
        </EditModal>
      )}
    </div>
  );
}
